export default __webpack_public_path__ + "static/media/9s.d9c41e74.png";